// extracted by mini-css-extract-plugin
export var aircallIframe = "_jz-3";
export var fabContainer = "_jz-5";
export var fabRinging = "_jz-6";
export var loadingOverlay = "_jz-4";
export var pulse = "_jz-7";
export var widgetContent = "_jz-2";
export var widgetPanel = "_jz-0";
export var widgetPanelExpanded = "_jz-1";